/* eslint-disable no-plusplus */

import {
  defaultDirection,
  defaultLocale,
  defaultColor,
  localeOptions,
  themeColorStorageKey,
  themeRadiusStorageKey,
} from "constants/defaultValues";

export const mapOrder = (array, order, key) => {
  // eslint-disable-next-line func-names
  array.sort(function (a, b) {
    const A = a[key];
    const B = b[key];
    if (order.indexOf(`${A}`) > order.indexOf(`${B}`)) {
      return 1;
    }
    return -1;
  });
  return array;
};

export const getDateWithFormat = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; // January is 0!

  const yyyy = today.getFullYear();
  if (dd < 10) {
    dd = `0${dd}`;
  }
  if (mm < 10) {
    mm = `0${mm}`;
  }
  return `${dd}.${mm}.${yyyy}`;
};

export const getCurrentTime = () => {
  const now = new Date();
  return `${now.getHours()}:${now.getMinutes()}`;
};

export const getDirection = () => {
  let direction = defaultDirection;

  try {
    if (localStorage.getItem("direction")) {
      const localValue = localStorage.getItem("direction");
      if (localValue === "rtl" || localValue === "ltr") {
        direction = localValue;
      }
    }
  } catch (error) {
    direction = defaultDirection;
  }
  return {
    direction,
    isRtl: direction === "rtl",
  };
};
export const setDirection = (localValue) => {
  let direction = "ltr";
  if (localValue === "rtl" || localValue === "ltr") {
    direction = localValue;
  }
  try {
    localStorage.setItem("direction", direction);
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : setDirection -> error", error);
  }
};

export const getCurrentColor = () => {
  let currentColor = defaultColor;
  try {
    if (localStorage.getItem(themeColorStorageKey)) {
      currentColor = localStorage.getItem(themeColorStorageKey);
    }
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : getCurrentColor -> error", error);
    currentColor = defaultColor;
  }
  return currentColor;
};

export const setCurrentColor = (color) => {
  try {
    localStorage.setItem(themeColorStorageKey, color);
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : setCurrentColor -> error", error);
  }
};

export const getCurrentRadius = () => {
  let currentRadius = "rounded";
  try {
    if (localStorage.getItem(themeRadiusStorageKey)) {
      currentRadius = localStorage.getItem(themeRadiusStorageKey);
    }
  } catch (error) {
    console.log(
      ">>>>: src/helpers/Utils.js : getCurrentRadius -> error",
      error
    );
    currentRadius = "rounded";
  }
  return currentRadius;
};
export const setCurrentRadius = (radius) => {
  try {
    localStorage.setItem(themeRadiusStorageKey, radius);
  } catch (error) {
    console.log(
      ">>>>: src/helpers/Utils.js : setCurrentRadius -> error",
      error
    );
  }
};

export const getCurrentLanguage = () => {
  let language = defaultLocale;
  try {
    language =
      localStorage.getItem("currentLanguage") &&
      localeOptions.filter(
        (x) => x.id === localStorage.getItem("currentLanguage")
      ).length > 0
        ? localStorage.getItem("currentLanguage")
        : defaultLocale;
  } catch (error) {
    console.log(
      ">>>>: src/helpers/Utils.js : getCurrentLanguage -> error",
      error
    );
    language = defaultLocale;
  }
  return language;
};
export const setCurrentLanguage = (locale) => {
  try {
    localStorage.setItem("currentLanguage", locale);
  } catch (error) {
    console.log(
      ">>>>: src/helpers/Utils.js : setCurrentLanguage -> error",
      error
    );
  }
};

export const getCurrentUser = () => {
  try {
    const user = localStorage.getItem("icard_current_user");

    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.log("Error retrieving current user:", error);
    return null;
  }
};

export const getPermissions = () => {
  const user = getCurrentUser();

  Object.keys(user).forEach((key) =>
    console.log(
      `Key: ${key}, Value: ${
        typeof user[key] === "object" ? JSON.stringify(user[key]) : user[key]
      }`
    )
  );
};

export const getToken = () => {
  try {
    const user = localStorage.getItem("token");
    return user || null;
  } catch (error) {
    console.log("Error retrieving token:", error);
    return null;
  }
};

export const setCurrentUser = (user) => {
  try {
    if (user) {
      localStorage.setItem("icard_current_user", JSON.stringify(user));
    } else {
      localStorage.removeItem("icard_current_user");
      localStorage.removeItem("expiryTime");
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("refreshToken");
    }
  } catch (error) {
    console.log("Error setting current user:", error);
  }
};

export const setTempLoginDetails = (tempToken, authProvider) => {
  try {
    sessionStorage.setItem("tempToken", tempToken);
    sessionStorage.setItem("authProvider", authProvider);
    sessionStorage.setItem("loggedIn", "true");
  } catch (error) {
    console.log("Error setting temporary login details:", error);
  }
};

export const clearTempSession = () => {
  sessionStorage.removeItem("tempToken");
  sessionStorage.removeItem("authProvider");
  sessionStorage.removeItem("loggedIn");
  console.log("Temporary session cleared");
};

export const getTempLoginDetails = () => {
  const tempToken = sessionStorage.getItem("tempToken");
  const authProvider = sessionStorage.getItem("authProvider");
  return { tempToken, authProvider };
};

export const clearSession = () => {
  try {
    localStorage.removeItem("icard_current_user");
    localStorage.removeItem("expiryTime");
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("refreshToken");
    sessionStorage.removeItem("hasSeenKycModal");
    clearTempSession();
  } catch (error) {
    console.log("Error clearing session:", error);
  }
};

export const setSession = (
  user,
  accessToken,
  refreshToken,
  expiryTime,
  role
) => {
  try {
    localStorage.setItem("icard_current_user", JSON.stringify(user));
    localStorage.setItem("token", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
    localStorage.setItem("expiryTime", expiryTime);
    localStorage.setItem("role", role);
  } catch (error) {
    console.log("Error setting session:", error);
    clearSession();
  }
};

export const updateSession = (accessToken, refreshToken, expiryTime) => {
  try {
    localStorage.setItem("token", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
    localStorage.setItem("expiryTime", expiryTime);
  } catch (error) {
    console.log("Error updating session:", error);
  }
};

export const getUserRole = () => {
  return localStorage.getItem("role");
};

export const getUserPermissions = () => {
  return localStorage.getItem("permission");
};

export const MakeId = (length) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
